import { E as EventProperties } from "../../index-5e4e4f4b.js";
import "../../axios-5f69b112.js";
import "../../_commonjsHelpers-0c53d963.js";
function analyticsEventForImpression(options = {}, base = {}) {
  return getAnalyticsEvent(
    options,
    {
      ...EventProperties.IMPRESSION,
      ...base
    },
    "impression"
  );
}
function analyticsEventForClick(options = {}, base = {}) {
  return getAnalyticsEvent(
    options,
    {
      ...EventProperties.CLICK,
      ...base
    },
    "click"
  );
}
function getAnalyticsEvent(options = {}, base = {}, key) {
  const { common, [key]: specific } = options;
  return common || specific ? {
    ...base,
    ...common,
    ...specific
  } : void 0;
}
export {
  analyticsEventForClick,
  analyticsEventForImpression
};
//# sourceMappingURL=utils.js.map
